export default "__VITE_ASSET__lRutzsXj__"